import './reminder-list-header.scss';

import { kebabCase } from 'lodash';
import { useCallback } from 'react';

import { ReminderSortField } from '../../../data/data/reminders/enums';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';

type ReminderListHeaderProps = {
  sortField?: ReminderSortField;
  sortOrder?: 'asc' | 'desc';
  onSort?: (field: ReminderSortField, order: 'asc' | 'desc') => void;
};

export function ReminderListHeader({
  sortField,
  sortOrder,
  onSort,
}: ReminderListHeaderProps) {
  const handleSortClick = useCallback(
    (field: ReminderSortField) => {
      if (!onSort) return;

      if (sortField === field) {
        // Toggle sort order if clicking the same field
        onSort(field, sortOrder === 'asc' ? 'desc' : 'asc');
      } else {
        // Change sort field and reset to ascending
        onSort(field, 'asc');
      }
    },
    [sortField, sortOrder, onSort]
  );

  const sortOptions = [
    ReminderSortField.NextSendDate,
    ReminderSortField.LastSendDate,
    ReminderSortField.PatientName,
  ];

  return (
    <div className="reminder-list-header">
      {sortOptions.map(option => (
        <button
          key={option}
          type="button"
          className={`reminder-list-header__option${
            sortField === option ? ' reminder-list-header__option--active' : ''
          }`}
          onClick={() => handleSortClick(option)}
        >
          <CustomFormattedMessage id={`reminders.sort.${kebabCase(option)}`} />
          <span className="reminder-list-header__indicator">
            {sortField === option && (sortOrder === 'asc' ? '↑' : '↓')}
          </span>
        </button>
      ))}
    </div>
  );
}
